export default __webpack_public_path__ + "static/media/detect.9983a9be.png";